module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.lineData) ? _c('div', [_c('div', {
    staticClass: "tab-panel padded relative"
  }, [_c('sales-overview', {
    attrs: {
      "height": 200,
      "width": 500,
      "chartData": _vm.lineData
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "options"
  }, [_c('v-select', {
    attrs: {
      "label": "description",
      "placeholder": "Results by ...",
      "options": _vm.ranges
    },
    model: {
      value: (_vm.selectedRange),
      callback: function($$v) {
        _vm.selectedRange = $$v
      },
      expression: "selectedRange"
    }
  })], 1)], 1), _vm._v(" "), (_vm.includeTotals && _vm.totals) ? _c('div', {
    staticClass: "border-top-light bg-lighter p-3 mt-3"
  }, [_c('div', {
    staticClass: "panel stats narrow flex-all d-flex"
  }, _vm._l((_vm.totals), function(total) {
    return _c('div', {
      staticClass: "separator mr-3 pr-5"
    }, [_c('h6', [_vm._v(_vm._s(total.label))]), _vm._v(" "), _c('h1', [_vm._v(_vm._s(total.value) + " €")])])
  }), 0)]) : _vm._e()]) : _vm._e()
},staticRenderFns: []}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-loader/node_modules/vue-hot-reload-api").rerender("data-v-6e086147", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-6e086147"}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/tools/Chart.vue
// module id = 1358
// module chunks = 0